<template>
	<v-form ref="form" v-model="valid" :value="valid" :lazy-validation="false">
		<v-select
			v-model="largeProcess.large_process_type_id"
			label="工程の種類(必須)"
			:rules="[rules.required]"
			:readonly="readonly"
			class="mt-4"
			outlined
			required
			dense
			:items="large_process_types"
			item-text="name"
			item-value="id"
			:hint="largeProcessType ? '' : '工程の種類を選択してください'"
			:persistent-hint="!largeProcessType"
			@change="setColumns"
		>
		</v-select>
		<template v-if="requiredOrderIndividualInfo && largeProcessType">
			<IncrementalSearchForm
				:label="'製造番号'"
				:classArray="['mt-4']"
				:value.sync="largeProcess.order_individual_info_id"
				:itemText="'get_product_info'"
				:targetName="'製品'"
				:url="`/erp/v1/large_process_types/${largeProcess.large_process_type_id}/search_order_individual_infos`"
				required
			>
				<template v-slot:append>
					<v-btn
						v-if="largeProcess.order_individual_info_id"
						icon
						color="primary"
						@click="setOrderIndividualInfo(largeProcess.order_individual_info_id)"
					>
						<v-icon>mdi-information</v-icon>
					</v-btn>
				</template>
			</IncrementalSearchForm>

			<!-- 案件よりもOrderIndividualInfoの方が良さそうなため、一時コメントアウト -->
			<!-- <v-row
				v-if="largeProcess.order_individual_info_id"
				no-gutters
				class="my-4 pb-4"
				justify="start"
			>
				<v-btn dark outlined @click="openMatterDialog" color="secondary">
					{{ selectedProduct }}
				</v-btn>
			</v-row> -->
		</template>

		<!-- 日程調整しないもの -->
		<template v-if="largeProcessType && !largeProcessType.schedule_arrangement_flag">
			<v-row no-gutters>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="工程開始予定日(生産企画)"
								:rules="largeProcess.planned_start_time ? [rules.required] : []"
								:hint="
									largeProcess.planned_start_time
										? '工程開始予定時刻がある場合は日付も入力が必要です。'
										: ''
								"
								:persistent-hint="
									largeProcess.planned_start_time != null && !largeProcess.planned_start_date
								"
								v-model="largeProcess.planned_start_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker
							v-model="largeProcess.planned_start_date"
							no-title
							scrollable
							locale="ja"
						/>
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="largeProcess.planned_start_time"
						label="工程開始予定時刻(生産企画)"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="工程完了予定日(生産企画)"
								:rules="largeProcess.planned_end_time ? [rules.required] : []"
								:hint="
									largeProcess.planned_end_time
										? '工程完了予定時刻がある場合は日付も入力が必要です。'
										: ''
								"
								:persistent-hint="
									largeProcess.planned_end_time != null && !largeProcess.planned_end_date
								"
								v-model="largeProcess.planned_end_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker
							v-model="largeProcess.planned_end_date"
							no-title
							scrollable
							locale="ja"
						/>
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="largeProcess.planned_end_time"
						label="工程完了予定時刻(生産企画)"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="工程開始予定日(製造)"
								:rules="largeProcess.schedule_start_time ? [rules.required] : []"
								:hint="
									largeProcess.schedule_start_time
										? '工程開始予定時刻がある場合は日付も入力が必要です。'
										: ''
								"
								:persistent-hint="
									largeProcess.schedule_start_time != null && !largeProcess.schedule_start_date
								"
								v-model="largeProcess.schedule_start_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker
							v-model="largeProcess.schedule_start_date"
							no-title
							scrollable
							locale="ja"
						/>
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="largeProcess.schedule_start_time"
						label="工程開始予定時刻(製造)"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="工程完了予定日(製造)"
								:rules="largeProcess.schedule_end_time ? [rules.required] : []"
								:hint="
									largeProcess.schedule_end_time
										? '工程完了予定時刻がある場合は日付も入力が必要です。'
										: ''
								"
								:persistent-hint="
									largeProcess.schedule_end_time != null && !largeProcess.schedule_end_date
								"
								v-model="largeProcess.schedule_end_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker
							v-model="largeProcess.schedule_end_date"
							no-title
							scrollable
							locale="ja"
						/>
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="largeProcess.schedule_end_time"
						label="工程完了予定時刻(製造)"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="工程開始日"
								:rules="largeProcess.start_time ? [rules.required] : []"
								:hint="
									largeProcess.start_time ? '工程開始時刻がある場合は日付も入力が必要です。' : ''
								"
								:persistent-hint="largeProcess.start_time != null && !largeProcess.start_date"
								v-model="largeProcess.start_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker v-model="largeProcess.start_date" no-title scrollable locale="ja" />
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="largeProcess.start_time"
						label="工程開始時刻"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="工程完了日"
								:rules="largeProcess.end_time ? [rules.required] : []"
								:hint="
									largeProcess.end_time ? '工程完了時刻がある場合は日付も入力が必要です。' : ''
								"
								:persistent-hint="largeProcess.end_time != null && !largeProcess.end_date"
								v-model="largeProcess.end_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker v-model="largeProcess.end_date" no-title scrollable locale="ja" />
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="largeProcess.end_time"
						label="工程完了時刻"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
			</v-row>
		</template>
		<!-- 日程調整する場合 -->

		<template v-else-if="largeProcessType && largeProcessType.schedule_arrangement_flag">
			<v-row no-gutters>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:label="`${largeProcessType.name}実行想定範囲(開始)`"
								:rules="[rules.required]"
								v-model="scheduleArrangementEstimatedStartDate"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker
							v-model="scheduleArrangementEstimatedStartDate"
							no-title
							scrollable
							locale="ja"
						/>
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:label="`${largeProcessType.name}実行想定範囲(終了)`"
								:rules="[rules.required]"
								v-model="scheduleArrangementEstimatedEndDate"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker
							v-model="scheduleArrangementEstimatedEndDate"
							no-title
							scrollable
							locale="ja"
						/>
					</v-menu>
				</v-col>

				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:label="`${largeProcessType.name}実行予定日(開始)`"
								:rules="[rules.required]"
								v-model="scheduleArrangementPlannedStartDate"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker
							v-model="scheduleArrangementPlannedStartDate"
							no-title
							scrollable
							locale="ja"
						/>
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="scheduleArrangementPlannedStartTime"
						:label="`${largeProcessType.name}実行予定時間(開始)`"
						:rules="[rules.required]"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:label="`${largeProcessType.name}実行予定日(終了)`"
								:rules="[rules.required]"
								v-model="scheduleArrangementPlannedEndDate"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker
							v-model="scheduleArrangementPlannedEndDate"
							no-title
							scrollable
							locale="ja"
						/>
					</v-menu>
				</v-col>

				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="scheduleArrangementPlannedEndTime"
						:label="`${largeProcessType.name}実行予定時間(終了)`"
						:rules="[rules.required]"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>

				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="工程開始日"
								:rules="largeProcess.start_time ? [rules.required] : []"
								:hint="
									largeProcess.start_time ? '工程開始時刻がある場合は日付も入力が必要です。' : ''
								"
								:persistent-hint="largeProcess.start_time != null && !largeProcess.start_date"
								v-model="largeProcess.start_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker v-model="largeProcess.start_date" no-title scrollable locale="ja" />
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="largeProcess.start_time"
						label="工程開始時刻"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
				<v-col cols="12" sm="6" class="pr-sm-1">
					<v-menu
						ref="menu"
						:close-on-content-click="false"
						close-on-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="工程完了日"
								:rules="largeProcess.end_time ? [rules.required] : []"
								:hint="
									largeProcess.end_time ? '工程完了時刻がある場合は日付も入力が必要です。' : ''
								"
								:persistent-hint="largeProcess.end_time != null && !largeProcess.end_date"
								v-model="largeProcess.end_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker v-model="largeProcess.end_date" no-title scrollable locale="ja" />
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" class="pl-sm-1">
					<v-text-field
						v-model="largeProcess.end_time"
						label="工程完了時刻"
						class="mt-4"
						type="time"
						step="1800"
						outlined
						dense
					/>
				</v-col>
			</v-row>
		</template>
		<LargeProcessValueForm
			v-for="(column, i) in largeProcessColumns"
			:key="column.id"
			:largeProcessColumn="column"
			:large_process_value.sync="large_process.large_process_values_attributes[i]"
		/>
		<v-textarea v-model="large_process.memo" label="特記事項" class="mt-4" outlined dense />
		<DragUpload
			@fileShare="fileShare"
			:fileResetFlag="fileResetFlag"
			:attached_files="large_process.attached_files ? large_process.attached_files : []"
		/>
		<v-row class="my-4" justify="center">
			<v-btn @click="submitForm" dense :disabled="!valid" color="secondary">
				<template v-if="formType == 'new'">
					<v-icon class="mr-1">mdi-plus</v-icon>
					登録する
				</template>
				<template v-else-if="formType == 'edit'">
					<v-icon class="mr-1">mdi-pencil</v-icon>
					編集する
				</template>
			</v-btn>
		</v-row>
		<!-- <MatterShowDialog
			v-if="matterDialog"
			:id="matterId"
			:requiredFetch="true"
			@close="matterDialog = false"
		/> -->
		<OrderIndividualInfoShowDialog
			:id="selectedId"
			:dialog.sync="orderIndividualInfoDialog"
			:editable="false"
		/>
	</v-form>
</template>

<script>
import moment from "moment/min/moment.min.js"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import LargeProcessValueForm from "./LargeProcessValueForm.vue"
import MatterShowDialog from "../../matter/components/MatterShowDialog.vue"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"
import DragUpload from "../../shared/DragUpload.vue"
import OrderIndividualInfoShowDialog from "../../order_individual_info/components/OrderIndividualInfoShowDialog.vue"

export default {
	name: "LargeProcessForm",
	components: {
		LargeProcessValueForm,
		MatterShowDialog,
		IncrementalSearchForm,
		DragUpload,
		OrderIndividualInfoShowDialog,
	},
	props: {
		large_process: {
			type: Object,
			required: false,
		},
		large_process_types: {
			type: Array,
			required: false,
			default: () => [],
		},
		// order_individual_infos: {
		// 	type: Array,
		// 	required: false,
		// 	default: () => [],
		// },
		large_process_type: {
			type: Number,
			required: false,
		},
		readonly: {
			type: Boolean,
			required: false,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
		current_company_name: {
			type: String,
			required: false,
		},
		requiredOrderIndividualInfo: {
			type: Boolean,
			required: false,
			default: true,
		},
		formType: {
			type: String,
			required: false,
			default: "new",
		},
		deleted_values: {
			type: Array,
			required: false,
			default: () => [],
		},
		fileResetFlag: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data() {
		return {
			largeProcessColumns: [],
			largeProcessType: {},
			selectedId: null,
			orderIndividualInfoDialog: false,
			scheduleArrangementEstimatedStartDate: null,
			scheduleArrangementEstimatedEndDate: null,
			scheduleArrangementPlannedStartDate: null,
			scheduleArrangementPlannedEndDate: null,
			scheduleArrangementPlannedStartTime: null,
			scheduleArrangementPlannedEndTime: null,
			rules: rules,
			common: common,
			valid: false,
			loading: false,
			error: null,
			matterDialog: false,
		}
	},
	mounted() {
		if (this.formType == "edit") {
			this.largeProcessType = this.large_process_types.find(
				(t) => t.id == this.largeProcess.large_process_type_id
			)
			if (!this.largeProcessType) {
				delete this.largeProcess.large_process_values
				return
			}
			this.largeProcessColumns = this.largeProcessType.meta_keys
			if (this.largeProcessType.schedule_arrangement_flag) this.setScheduleArrangement()
		} else {
			this.setColumns()
		}
	},
	methods: {
		setColumns() {
			this.largeProcessType = this.large_process_types.find(
				(p) => p.id == this.largeProcess.large_process_type_id
			)

			const deletedValues = this.largeProcess.large_process_values_attributes
				.filter((v) => v.id != null)
				.map((v) => ({ id: v.id, _destroy: true }))
			this.deletedValues = this.deletedValues.concat(deletedValues)

			if (!this.largeProcessType) {
				this.largeProcessColumns = []
				this.largeProcess.large_process_values_attributes = []
				delete this.largeProcess.schedule_arrangement_attributes
				return
			}

			this.largeProcess.large_process_values_attributes = this.largeProcessType.meta_keys.map(
				(c) => {
					let meta_value = { large_process_column_id: c.id }
					if (c.data_type == "target") {
						meta_value.value_target_id = null
						meta_value.value_target_type = null
					} else {
						meta_value[`value_${c.data_type}`] = null
					}
					return meta_value
				}
			)
			if (this.largeProcessType.schedule_arrangement_flag) {
				this.largeProcess.schedule_arrangement_attributes = {
					estimated_start_date: null,
					estimated_end_date: null,
					planned_start_time: null,
					planned_end_time: null,
					user_id: this.$store.getters["auth/authData"].id,
				}
			} else {
				delete this.largeProcess.schedule_arrangement_attributes
			}

			this.largeProcessColumns = this.largeProcessType.meta_keys
		},
		openMatterDialog() {
			this.matterDialog = true
			this.$emit("is-window-size-check", true)
		},
		submitForm() {
			this.$emit("submit-form", this.largeProcessType.schedule_arrangement_flag)
		},
		setOrderIndividualInfo(id) {
			this.selectedId = id
			this.orderIndividualInfoDialog = true
		},
		setScheduleArrangement() {
			this.scheduleArrangementEstimatedStartDate =
				this.largeProcess.schedule_arrangement_attributes.estimated_start_date
			this.scheduleArrangementEstimatedEndDate =
				this.largeProcess.schedule_arrangement_attributes.estimated_end_date
			this.scheduleArrangementPlannedStartDate = this.largeProcess.schedule_arrangement_attributes
				.planned_start_time
				? moment(this.largeProcess.schedule_arrangement_attributes.planned_start_time).format(
						"YYYY-MM-DD"
				  )
				: null
			this.scheduleArrangementPlannedEndDate = this.largeProcess.schedule_arrangement_attributes
				.planned_end_time
				? moment(this.largeProcess.schedule_arrangement_attributes.planned_end_time).format(
						"YYYY-MM-DD"
				  )
				: null
			this.scheduleArrangementPlannedStartTime = this.largeProcess.schedule_arrangement_attributes
				.planned_start_time
				? moment(this.largeProcess.schedule_arrangement_attributes.planned_start_time).format(
						"HH:mm"
				  )
				: null
			this.scheduleArrangementPlannedEndTime = this.largeProcess.schedule_arrangement_attributes
				.planned_end_time
				? moment(this.largeProcess.schedule_arrangement_attributes.planned_end_time).format("HH:mm")
				: null
		},
		fileShare(added_files) {
			// TODO
			const files = []
			Object.entries(added_files).forEach((file) => {
				files.push(file[1])
			})
			this.$emit("add-files", files)
		},
	},
	computed: {
		largeProcess: {
			get() {
				return this.large_process
			},
			set(newVal) {
				return this.$emit("update:largeProcess", newVal)
			},
		},
		deletedValues: {
			get() {
				return this.deleted_values
			},
			set(newVal) {
				return this.$emit("update:deleted_values", newVal)
			},
		},
		// TODO order_individual_infosが必要であればnew,editアクションで取得
		// matterId() {
		// 	let order_individual_info = this.order_individual_infos.find(
		// 		(v) => v.id == this.large_process.order_individual_info_id
		// 	)
		// 	if (!order_individual_info) return
		// 	if (order_individual_info.ordered_product) {
		// 		return order_individual_info.ordered_product.matter_id
		// 	} else {
		// 		return order_individual_info.matter_product.matter_id
		// 	}
		// },

		// TODO order_individual_infosが必要であればnew,editアクションで取得
		// selectedProduct() {
		// 	let order_individual_info = this.order_individual_infos.find(
		// 		(v) => v.id == this.large_process.order_individual_info_id
		// 	)
		// 	if (!order_individual_info) return
		// 	return common.productNameWithProductNumber(order_individual_info)
		// },
	},
	watch: {
		large_process_type(newVal, _) {
			this.large_process.large_process_type_id = newVal
			this.setColumns()
		},
		large_process(newVal, _) {
			this.largeProcessType = this.large_process_types.find(
				(t) => t.id == newVal.large_process_type_id
			)
			if (!this.largeProcessType) {
				return
			}
			if (this.largeProcess.id != newVal.id) {
				this.setScheduleArrangement()
			}
			this.largeProcessColumns = this.largeProcessType.meta_keys
		},

		scheduleArrangementPlannedStartDate(newVal, _) {
			if (this.scheduleArrangementPlannedStartTime && newVal) {
				this.largeProcess.schedule_arrangement_attributes.planned_start_time = `${newVal} ${this.scheduleArrangementPlannedStartTime}`
			} else {
				this.largeProcess.schedule_arrangement_attributes.planned_start_time = null
			}
		},
		scheduleArrangementPlannedEndDate(newVal, _) {
			if (this.scheduleArrangementPlannedEndTime && newVal) {
				this.largeProcess.schedule_arrangement_attributes.planned_end_time = `${newVal} ${this.scheduleArrangementPlannedEndTime}`
			} else {
				this.largeProcess.schedule_arrangement_attributes.planned_end_time = null
			}
		},
		scheduleArrangementPlannedStartTime(newVal, _) {
			if (this.scheduleArrangementPlannedStartDate && newVal) {
				this.largeProcess.schedule_arrangement_attributes.planned_start_time = `${this.scheduleArrangementPlannedStartDate} ${newVal}`
			} else {
				this.largeProcess.schedule_arrangement_attributes.planned_start_time = null
			}
		},
		scheduleArrangementPlannedEndTime(newVal, _) {
			if (this.scheduleArrangementPlannedEndDate && newVal) {
				this.largeProcess.schedule_arrangement_attributes.planned_end_time = `${this.scheduleArrangementPlannedEndDate} ${newVal}`
			} else {
				this.largeProcess.schedule_arrangement_attributes.planned_end_time = null
			}
		},
		scheduleArrangementEstimatedStartDate(newVal) {
			this.largeProcess.schedule_arrangement_attributes.estimated_start_date = newVal
		},
		scheduleArrangementEstimatedEndDate(newVal) {
			this.largeProcess.schedule_arrangement_attributes.estimated_end_date = newVal
		},
	},
}
</script>

<style></style>
